import { render, staticRenderFns } from "./infrared-of-day.vue?vue&type=template&id=5b59cd84&scoped=true"
import script from "./infrared-of-day.vue?vue&type=script&lang=js"
export * from "./infrared-of-day.vue?vue&type=script&lang=js"
import style0 from "./infrared-of-day.vue?vue&type=style&index=0&id=5b59cd84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59cd84",
  null
  
)

export default component.exports